import { requestApi } from "../../utils/requests";
import * as cookiesUtils from "../../../packs/utils/cookies";
import { validateEmail } from "../../utils/validations";

function addNewsletterSubscriptionClosedCookie() {
  cookiesUtils.setCookie("newsletter_subscription_closed", 1, 1);
}

function addNewsletterSubscriptionSubscribedCookie() {
  cookiesUtils.setCookie("newsletter_subscription_subscribed", 1, 730);
}

function submitNewsletterRegistration(form) {
  // eslint-disable-next-line no-undef
  const formData = new FormData(form);
  requestApi({
    method: form.method,
    route: form.action,
    data: Object.fromEntries(formData),
  }).then(() => {
    form.classList.add("d-none");
    form.nextElementSibling.classList.remove("d-none");
    // eslint-disable-next-line no-undef
    document.dispatchEvent(new Event("ajaxComplete"));
    addNewsletterSubscriptionSubscribedCookie();
  });
}

function validateEmailForForm(emailInput, form) {
  const submitButton = form.querySelector('button[type="submit"]');

  submitButton.disabled = !validateEmail(emailInput.value);
}

function handleSubmit(event) {
  event.preventDefault();
  submitNewsletterRegistration(event.target);
}

function addListenerToNewsletterSubscriptionForm() {
  const cookiesForms = document.querySelectorAll(".js-newsletter-subscription-form");
  cookiesForms.forEach((elem) => {
    elem.addEventListener("submit", handleSubmit);
    const emailInput = elem.querySelector(".js-validate-email");
    if (emailInput) {
      emailInput.addEventListener("keyup", () => validateEmailForForm(emailInput, elem));
      emailInput.addEventListener("change", () => validateEmailForForm(emailInput, elem));
    }
  });
}

document.addEventListener(
  "modal.newsletter_subscription.open",
  addListenerToNewsletterSubscriptionForm
);

document.addEventListener(
  "modal.newsletter_subscription.close",
  addNewsletterSubscriptionClosedCookie
);
